import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "status"]
  static values = { delay: { type: Number, default: 2000 } }

  connect() {
    if (!this.hasContentTarget) return
    this.contentTarget.hidden = true
    this.statusTarget.hidden = false
    this.statusTarget.dataset.loading = "true"
    this.timer = setTimeout(() => {
      this.contentTarget.hidden = false
      this.statusTarget.hidden = true
      this.statusTarget.dataset.loading = "false"
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
